import { default as PlatformHomeHFL6YpB4iyMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/components/PlatformHome.vue?macro=true";
import { default as SiteHomeGE4LdzCvA5Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/components/SiteHome.vue?macro=true";
import { default as indexH7Mu5K9ZI9Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/index.vue?macro=true";
import { default as indexbV9qWDHBkOMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/index.vue?macro=true";
import { default as loginTQsr3gthxkMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/login.vue?macro=true";
import { default as detail2TEVEGpYMWMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-agent/detail.vue?macro=true";
import { default as indexoun5JDp4w7Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-agent/index.vue?macro=true";
import { default as indexpJYtTMPCnqMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/index.vue?macro=true";
import { default as mchCWa9px7MbRMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/mch.vue?macro=true";
import { default as detailxw2GS9LURnMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/order/detail.vue?macro=true";
import { default as indexuwYFSTDXofMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/order/index.vue?macro=true";
import { default as productnpjHMTeE6XMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/product.vue?macro=true";
import { default as transactionCFJAaLHyChMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/transaction.vue?macro=true";
import { default as detailKCLNFfxFdzMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/detail.vue?macro=true";
import { default as indexNIeRDZsdf2Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/index.vue?macro=true";
import { default as user_45user_45editB9fCTxlOuqMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/user-user-edit.tsx?macro=true";
import { default as wechatQzUYS3SJFQMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/wechat.vue?macro=true";
import { default as PanelSiteQuestiontgbyexc8X9Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/components/PanelSiteQuestion.vue?macro=true";
import { default as index1CA7YscyPwMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/index.vue?macro=true";
import { default as listZNxH4WrwytMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/list.vue?macro=true";
import { default as transfer_45site_45siteprrY7Bg7DkMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer-site-site.vue?macro=true";
import { default as transfer_45sitehkTkiF8dNlMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer-site.vue?macro=true";
import { default as transferrmEQOjhX4TMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer.vue?macro=true";
import { default as adminonYiT7nIbZMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/admin.tsx?macro=true";
import { default as generalmAtd3R3HbGMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/general.tsx?macro=true";
import { default as indexmlrSlT3WhEMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/index.vue?macro=true";
import { default as roleUJPROZCy07Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/role.vue?macro=true";
import { default as tagsyd491VchF8Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/tags.vue?macro=true";
import { default as test_45paperUokArUXDFnMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/test-paper.tsx?macro=true";
import { default as user_45homenbNmK1175GMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/user-home.vue?macro=true";
import { default as detailOCB7eEboOsMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/detail.vue?macro=true";
import { default as indexVzSfHIs63cMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/index.vue?macro=true";
import { default as list1JbGlTO6igMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/list.vue?macro=true";
import { default as site_45licenseKdHI5kuun6Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/site-license.tsx?macro=true";
import { default as agentoTHTPk2pzEMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/agent.vue?macro=true";
import { default as index7UVKOHvwl8Meta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/index.vue?macro=true";
import { default as platformjPDz6lsw9EMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/platform.vue?macro=true";
import { default as question3RzwLbbu5EMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/question.vue?macro=true";
import { default as sitePhthprc6BWMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/site.vue?macro=true";
import { default as detailvHHtLySZbaMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/detail.vue?macro=true";
import { default as indexL3pqt37SbPMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/index.vue?macro=true";
import { default as listThOJLoc9SpMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/list.vue?macro=true";
import { default as login_45idUwygbx42blMeta } from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/login-id.vue?macro=true";
export default [
  {
    name: PlatformHomeHFL6YpB4iyMeta?.name ?? "home-components-PlatformHome",
    path: PlatformHomeHFL6YpB4iyMeta?.path ?? "/home/components/PlatformHome",
    meta: PlatformHomeHFL6YpB4iyMeta || {},
    alias: PlatformHomeHFL6YpB4iyMeta?.alias || [],
    redirect: PlatformHomeHFL6YpB4iyMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/components/PlatformHome.vue").then(m => m.default || m)
  },
  {
    name: SiteHomeGE4LdzCvA5Meta?.name ?? "home-components-SiteHome",
    path: SiteHomeGE4LdzCvA5Meta?.path ?? "/home/components/SiteHome",
    meta: SiteHomeGE4LdzCvA5Meta || {},
    alias: SiteHomeGE4LdzCvA5Meta?.alias || [],
    redirect: SiteHomeGE4LdzCvA5Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/components/SiteHome.vue").then(m => m.default || m)
  },
  {
    name: indexH7Mu5K9ZI9Meta?.name ?? "home",
    path: indexH7Mu5K9ZI9Meta?.path ?? "/home",
    meta: indexH7Mu5K9ZI9Meta || {},
    alias: indexH7Mu5K9ZI9Meta?.alias || [],
    redirect: indexH7Mu5K9ZI9Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: indexbV9qWDHBkOMeta?.name ?? "index",
    path: indexbV9qWDHBkOMeta?.path ?? "/",
    meta: indexbV9qWDHBkOMeta || {},
    alias: indexbV9qWDHBkOMeta?.alias || [],
    redirect: indexbV9qWDHBkOMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginTQsr3gthxkMeta?.name ?? "login",
    path: loginTQsr3gthxkMeta?.path ?? "/login",
    meta: loginTQsr3gthxkMeta || {},
    alias: loginTQsr3gthxkMeta?.alias || [],
    redirect: loginTQsr3gthxkMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/login.vue").then(m => m.default || m)
  },
  {
    name: detail2TEVEGpYMWMeta?.name ?? "mgr-agent-detail",
    path: detail2TEVEGpYMWMeta?.path ?? "/mgr-agent/detail",
    meta: detail2TEVEGpYMWMeta || {},
    alias: detail2TEVEGpYMWMeta?.alias || [],
    redirect: detail2TEVEGpYMWMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-agent/detail.vue").then(m => m.default || m)
  },
  {
    name: indexoun5JDp4w7Meta?.name ?? "mgr-agent",
    path: indexoun5JDp4w7Meta?.path ?? "/mgr-agent",
    meta: indexoun5JDp4w7Meta || {},
    alias: indexoun5JDp4w7Meta?.alias || [],
    redirect: indexoun5JDp4w7Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-agent/index.vue").then(m => m.default || m)
  },
  {
    name: indexpJYtTMPCnqMeta?.name ?? "mgr-app",
    path: indexpJYtTMPCnqMeta?.path ?? "/mgr-app",
    meta: indexpJYtTMPCnqMeta || {},
    alias: indexpJYtTMPCnqMeta?.alias || [],
    redirect: indexpJYtTMPCnqMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/index.vue").then(m => m.default || m)
  },
  {
    name: mchCWa9px7MbRMeta?.name ?? "mgr-app-mch",
    path: mchCWa9px7MbRMeta?.path ?? "/mgr-app/mch",
    meta: mchCWa9px7MbRMeta || {},
    alias: mchCWa9px7MbRMeta?.alias || [],
    redirect: mchCWa9px7MbRMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/mch.vue").then(m => m.default || m)
  },
  {
    name: detailxw2GS9LURnMeta?.name ?? "mgr-app-order-detail",
    path: detailxw2GS9LURnMeta?.path ?? "/mgr-app/order/detail",
    meta: detailxw2GS9LURnMeta || {},
    alias: detailxw2GS9LURnMeta?.alias || [],
    redirect: detailxw2GS9LURnMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/order/detail.vue").then(m => m.default || m)
  },
  {
    name: indexuwYFSTDXofMeta?.name ?? "mgr-app-order",
    path: indexuwYFSTDXofMeta?.path ?? "/mgr-app/order",
    meta: indexuwYFSTDXofMeta || {},
    alias: indexuwYFSTDXofMeta?.alias || [],
    redirect: indexuwYFSTDXofMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/order/index.vue").then(m => m.default || m)
  },
  {
    name: productnpjHMTeE6XMeta?.name ?? "mgr-app-product",
    path: productnpjHMTeE6XMeta?.path ?? "/mgr-app/product",
    meta: productnpjHMTeE6XMeta || {},
    alias: productnpjHMTeE6XMeta?.alias || [],
    redirect: productnpjHMTeE6XMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/product.vue").then(m => m.default || m)
  },
  {
    name: transactionCFJAaLHyChMeta?.name ?? "mgr-app-transaction",
    path: transactionCFJAaLHyChMeta?.path ?? "/mgr-app/transaction",
    meta: transactionCFJAaLHyChMeta || {},
    alias: transactionCFJAaLHyChMeta?.alias || [],
    redirect: transactionCFJAaLHyChMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/transaction.vue").then(m => m.default || m)
  },
  {
    name: detailKCLNFfxFdzMeta?.name ?? "mgr-app-user-detail",
    path: detailKCLNFfxFdzMeta?.path ?? "/mgr-app/user/detail",
    meta: detailKCLNFfxFdzMeta || {},
    alias: detailKCLNFfxFdzMeta?.alias || [],
    redirect: detailKCLNFfxFdzMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/detail.vue").then(m => m.default || m)
  },
  {
    name: indexNIeRDZsdf2Meta?.name ?? "mgr-app-user",
    path: indexNIeRDZsdf2Meta?.path ?? "/mgr-app/user",
    meta: indexNIeRDZsdf2Meta || {},
    alias: indexNIeRDZsdf2Meta?.alias || [],
    redirect: indexNIeRDZsdf2Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/index.vue").then(m => m.default || m)
  },
  {
    name: user_45user_45editB9fCTxlOuqMeta?.name ?? "mgr-app-user-user-user-edit",
    path: user_45user_45editB9fCTxlOuqMeta?.path ?? "/mgr-app/user/user-user-edit",
    meta: user_45user_45editB9fCTxlOuqMeta || {},
    alias: user_45user_45editB9fCTxlOuqMeta?.alias || [],
    redirect: user_45user_45editB9fCTxlOuqMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/user/user-user-edit.tsx").then(m => m.default || m)
  },
  {
    name: wechatQzUYS3SJFQMeta?.name ?? "mgr-app-wechat",
    path: wechatQzUYS3SJFQMeta?.path ?? "/mgr-app/wechat",
    meta: wechatQzUYS3SJFQMeta || {},
    alias: wechatQzUYS3SJFQMeta?.alias || [],
    redirect: wechatQzUYS3SJFQMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-app/wechat.vue").then(m => m.default || m)
  },
  {
    name: PanelSiteQuestiontgbyexc8X9Meta?.name ?? "mgr-question-components-PanelSiteQuestion",
    path: PanelSiteQuestiontgbyexc8X9Meta?.path ?? "/mgr-question/components/PanelSiteQuestion",
    meta: PanelSiteQuestiontgbyexc8X9Meta || {},
    alias: PanelSiteQuestiontgbyexc8X9Meta?.alias || [],
    redirect: PanelSiteQuestiontgbyexc8X9Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/components/PanelSiteQuestion.vue").then(m => m.default || m)
  },
  {
    name: index1CA7YscyPwMeta?.name ?? "mgr-question",
    path: index1CA7YscyPwMeta?.path ?? "/mgr-question",
    meta: index1CA7YscyPwMeta || {},
    alias: index1CA7YscyPwMeta?.alias || [],
    redirect: index1CA7YscyPwMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/index.vue").then(m => m.default || m)
  },
  {
    name: listZNxH4WrwytMeta?.name ?? "mgr-question-list",
    path: listZNxH4WrwytMeta?.path ?? "/mgr-question/list",
    meta: listZNxH4WrwytMeta || {},
    alias: listZNxH4WrwytMeta?.alias || [],
    redirect: listZNxH4WrwytMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/list.vue").then(m => m.default || m)
  },
  {
    name: transfer_45site_45siteprrY7Bg7DkMeta?.name ?? "mgr-question-transfer-site-site",
    path: transfer_45site_45siteprrY7Bg7DkMeta?.path ?? "/mgr-question/transfer-site-site",
    meta: transfer_45site_45siteprrY7Bg7DkMeta || {},
    alias: transfer_45site_45siteprrY7Bg7DkMeta?.alias || [],
    redirect: transfer_45site_45siteprrY7Bg7DkMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer-site-site.vue").then(m => m.default || m)
  },
  {
    name: transfer_45sitehkTkiF8dNlMeta?.name ?? "mgr-question-transfer-site",
    path: transfer_45sitehkTkiF8dNlMeta?.path ?? "/mgr-question/transfer-site",
    meta: transfer_45sitehkTkiF8dNlMeta || {},
    alias: transfer_45sitehkTkiF8dNlMeta?.alias || [],
    redirect: transfer_45sitehkTkiF8dNlMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer-site.vue").then(m => m.default || m)
  },
  {
    name: transferrmEQOjhX4TMeta?.name ?? "mgr-question-transfer",
    path: transferrmEQOjhX4TMeta?.path ?? "/mgr-question/transfer",
    meta: transferrmEQOjhX4TMeta || {},
    alias: transferrmEQOjhX4TMeta?.alias || [],
    redirect: transferrmEQOjhX4TMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-question/transfer.vue").then(m => m.default || m)
  },
  {
    name: adminonYiT7nIbZMeta?.name ?? "mgr-setting-admin",
    path: adminonYiT7nIbZMeta?.path ?? "/mgr-setting/admin",
    meta: adminonYiT7nIbZMeta || {},
    alias: adminonYiT7nIbZMeta?.alias || [],
    redirect: adminonYiT7nIbZMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/admin.tsx").then(m => m.default || m)
  },
  {
    name: generalmAtd3R3HbGMeta?.name ?? "mgr-setting-general",
    path: generalmAtd3R3HbGMeta?.path ?? "/mgr-setting/general",
    meta: generalmAtd3R3HbGMeta || {},
    alias: generalmAtd3R3HbGMeta?.alias || [],
    redirect: generalmAtd3R3HbGMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/general.tsx").then(m => m.default || m)
  },
  {
    name: indexmlrSlT3WhEMeta?.name ?? "mgr-setting",
    path: indexmlrSlT3WhEMeta?.path ?? "/mgr-setting",
    meta: indexmlrSlT3WhEMeta || {},
    alias: indexmlrSlT3WhEMeta?.alias || [],
    redirect: indexmlrSlT3WhEMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/index.vue").then(m => m.default || m)
  },
  {
    name: roleUJPROZCy07Meta?.name ?? "mgr-setting-role",
    path: roleUJPROZCy07Meta?.path ?? "/mgr-setting/role",
    meta: roleUJPROZCy07Meta || {},
    alias: roleUJPROZCy07Meta?.alias || [],
    redirect: roleUJPROZCy07Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/role.vue").then(m => m.default || m)
  },
  {
    name: tagsyd491VchF8Meta?.name ?? "mgr-setting-tags",
    path: tagsyd491VchF8Meta?.path ?? "/mgr-setting/tags",
    meta: tagsyd491VchF8Meta || {},
    alias: tagsyd491VchF8Meta?.alias || [],
    redirect: tagsyd491VchF8Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/tags.vue").then(m => m.default || m)
  },
  {
    name: test_45paperUokArUXDFnMeta?.name ?? "mgr-setting-test-paper",
    path: test_45paperUokArUXDFnMeta?.path ?? "/mgr-setting/test-paper",
    meta: test_45paperUokArUXDFnMeta || {},
    alias: test_45paperUokArUXDFnMeta?.alias || [],
    redirect: test_45paperUokArUXDFnMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/test-paper.tsx").then(m => m.default || m)
  },
  {
    name: user_45homenbNmK1175GMeta?.name ?? "mgr-setting-user-home",
    path: user_45homenbNmK1175GMeta?.path ?? "/mgr-setting/user-home",
    meta: user_45homenbNmK1175GMeta || {},
    alias: user_45homenbNmK1175GMeta?.alias || [],
    redirect: user_45homenbNmK1175GMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-setting/user-home.vue").then(m => m.default || m)
  },
  {
    name: detailOCB7eEboOsMeta?.name ?? "mgr-site-detail",
    path: detailOCB7eEboOsMeta?.path ?? "/mgr-site/detail",
    meta: detailOCB7eEboOsMeta || {},
    alias: detailOCB7eEboOsMeta?.alias || [],
    redirect: detailOCB7eEboOsMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/detail.vue").then(m => m.default || m)
  },
  {
    name: indexVzSfHIs63cMeta?.name ?? "mgr-site",
    path: indexVzSfHIs63cMeta?.path ?? "/mgr-site",
    meta: indexVzSfHIs63cMeta || {},
    alias: indexVzSfHIs63cMeta?.alias || [],
    redirect: indexVzSfHIs63cMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/index.vue").then(m => m.default || m)
  },
  {
    name: list1JbGlTO6igMeta?.name ?? "mgr-site-list",
    path: list1JbGlTO6igMeta?.path ?? "/mgr-site/list",
    meta: list1JbGlTO6igMeta || {},
    alias: list1JbGlTO6igMeta?.alias || [],
    redirect: list1JbGlTO6igMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/list.vue").then(m => m.default || m)
  },
  {
    name: site_45licenseKdHI5kuun6Meta?.name ?? "mgr-site-site-license",
    path: site_45licenseKdHI5kuun6Meta?.path ?? "/mgr-site/site-license",
    meta: site_45licenseKdHI5kuun6Meta || {},
    alias: site_45licenseKdHI5kuun6Meta?.alias || [],
    redirect: site_45licenseKdHI5kuun6Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-site/site-license.tsx").then(m => m.default || m)
  },
  {
    name: agentoTHTPk2pzEMeta?.name ?? "mgr-stat-agent",
    path: agentoTHTPk2pzEMeta?.path ?? "/mgr-stat/agent",
    meta: agentoTHTPk2pzEMeta || {},
    alias: agentoTHTPk2pzEMeta?.alias || [],
    redirect: agentoTHTPk2pzEMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/agent.vue").then(m => m.default || m)
  },
  {
    name: index7UVKOHvwl8Meta?.name ?? "mgr-stat",
    path: index7UVKOHvwl8Meta?.path ?? "/mgr-stat",
    meta: index7UVKOHvwl8Meta || {},
    alias: index7UVKOHvwl8Meta?.alias || [],
    redirect: index7UVKOHvwl8Meta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/index.vue").then(m => m.default || m)
  },
  {
    name: platformjPDz6lsw9EMeta?.name ?? "mgr-stat-platform",
    path: platformjPDz6lsw9EMeta?.path ?? "/mgr-stat/platform",
    meta: platformjPDz6lsw9EMeta || {},
    alias: platformjPDz6lsw9EMeta?.alias || [],
    redirect: platformjPDz6lsw9EMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/platform.vue").then(m => m.default || m)
  },
  {
    name: question3RzwLbbu5EMeta?.name ?? "mgr-stat-question",
    path: question3RzwLbbu5EMeta?.path ?? "/mgr-stat/question",
    meta: question3RzwLbbu5EMeta || {},
    alias: question3RzwLbbu5EMeta?.alias || [],
    redirect: question3RzwLbbu5EMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/question.vue").then(m => m.default || m)
  },
  {
    name: sitePhthprc6BWMeta?.name ?? "mgr-stat-site",
    path: sitePhthprc6BWMeta?.path ?? "/mgr-stat/site",
    meta: sitePhthprc6BWMeta || {},
    alias: sitePhthprc6BWMeta?.alias || [],
    redirect: sitePhthprc6BWMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-stat/site.vue").then(m => m.default || m)
  },
  {
    name: detailvHHtLySZbaMeta?.name ?? "mgr-trainee-detail",
    path: detailvHHtLySZbaMeta?.path ?? "/mgr-trainee/detail",
    meta: detailvHHtLySZbaMeta || {},
    alias: detailvHHtLySZbaMeta?.alias || [],
    redirect: detailvHHtLySZbaMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/detail.vue").then(m => m.default || m)
  },
  {
    name: indexL3pqt37SbPMeta?.name ?? "mgr-trainee",
    path: indexL3pqt37SbPMeta?.path ?? "/mgr-trainee",
    meta: indexL3pqt37SbPMeta || {},
    alias: indexL3pqt37SbPMeta?.alias || [],
    redirect: indexL3pqt37SbPMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/index.vue").then(m => m.default || m)
  },
  {
    name: listThOJLoc9SpMeta?.name ?? "mgr-trainee-list",
    path: listThOJLoc9SpMeta?.path ?? "/mgr-trainee/list",
    meta: listThOJLoc9SpMeta || {},
    alias: listThOJLoc9SpMeta?.alias || [],
    redirect: listThOJLoc9SpMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/list.vue").then(m => m.default || m)
  },
  {
    name: login_45idUwygbx42blMeta?.name ?? "mgr-trainee-login-id",
    path: login_45idUwygbx42blMeta?.path ?? "/mgr-trainee/login-id",
    meta: login_45idUwygbx42blMeta || {},
    alias: login_45idUwygbx42blMeta?.alias || [],
    redirect: login_45idUwygbx42blMeta?.redirect,
    component: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/pages/mgr-trainee/login-id.vue").then(m => m.default || m)
  }
]